<template>
  <div class="form-group">
    <label>{{$t('card_number')}}</label>
    <div class="card-input-container">
      <input
          ref="cardInput"
          type="text"
          v-model="displayValue"
          @input="handleInput"
          @keydown="handleKeydown"
          @paste="handlePaste"
          @focus="handleFocus"
          @blur="handleBlur"
          :placeholder="$t('card_number')"
          class="card-input"
          :maxlength="maxLength"
          autocomplete="cc-number"
          inputmode="numeric"
      >

      <div class="card-icons">
        <svg v-if="cardType === 'visa'" width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" fill="white"/>
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" stroke="#F9FAFB"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.751 16.3579H8.69129L7.14674 10.292C7.07343 10.013 6.91776 9.76627 6.68879 9.65001C6.11737 9.35784 5.4877 9.12531 4.80078 9.00804V8.7745H8.11886C8.57681 8.7745 8.92026 9.12531 8.97751 9.53274L9.77891 13.9083L11.8376 8.7745H13.8401L10.751 16.3579ZM14.985 16.3579H13.0398L14.6415 8.7745H16.5868L14.985 16.3579ZM19.1035 10.8753C19.1607 10.4669 19.5042 10.2334 19.9049 10.2334C20.5346 10.1747 21.2205 10.292 21.7929 10.5832L22.1364 8.95042C21.5639 8.71688 20.9343 8.59961 20.3628 8.59961C18.4748 8.59961 17.101 9.65002 17.101 11.1078C17.101 12.2169 18.0741 12.7992 18.761 13.15C19.5042 13.4998 19.7904 13.7334 19.7332 14.0832C19.7332 14.6079 19.1607 14.8414 18.5893 14.8414C17.9024 14.8414 17.2155 14.6665 16.5868 14.3743L16.2433 16.0081C16.9303 16.2992 17.6734 16.4165 18.3603 16.4165C20.4773 16.4741 21.7929 15.4247 21.7929 13.8496C21.7929 11.8661 19.1035 11.7498 19.1035 10.8753ZM28.6008 16.3579L27.0562 8.7745H25.3972C25.0537 8.7745 24.7103 9.00804 24.5958 9.35784L21.7356 16.3579H23.7381L24.1378 15.2498H26.5983L26.8273 16.3579H28.6008ZM25.6834 10.8167L26.2548 13.6747H24.653L25.6834 10.8167Z" fill="#172B85"/>
        </svg>

        <svg v-if="cardType === 'mastercard'" width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" fill="white"/>
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" stroke="#F9FAFB"/>
          <path d="M21.5771 5.5293C25.322 5.5293 28.3584 8.52918 28.3584 12.2295C28.3583 15.9297 25.322 18.9297 21.5771 18.9297C19.8982 18.9297 18.3629 18.3249 17.1787 17.3262C15.9945 18.3248 14.4591 18.9297 12.7803 18.9297C9.03566 18.9295 6.00011 15.9296 6 12.2295C6 8.52932 9.03559 5.52952 12.7803 5.5293C14.459 5.5293 15.9945 6.13337 17.1787 7.13184C18.3629 6.13324 19.8983 5.52932 21.5771 5.5293Z" fill="#ED0006"/>
          <path d="M21.5781 5.5293C25.3229 5.52938 28.3584 8.52923 28.3584 12.2295C28.3583 15.9297 25.3229 18.9296 21.5781 18.9297C19.8992 18.9297 18.3639 18.3249 17.1797 17.3262C18.6368 16.0973 19.5624 14.2708 19.5625 12.2295C19.5625 10.188 18.6371 8.36073 17.1797 7.13184C18.3639 6.1333 19.8993 5.5293 21.5781 5.5293Z" fill="#F9A000"/>
          <path d="M17.1787 7.13086C18.6363 8.35976 19.5615 10.1869 19.5615 12.2285C19.5615 14.2699 18.636 16.0963 17.1787 17.3252C15.7217 16.0963 14.7969 14.2696 14.7969 12.2285C14.7969 10.1872 15.7215 8.35975 17.1787 7.13086Z" fill="#FF5E00"/>
        </svg>

        <svg v-if="cardType === 'amex'" width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" fill="white"/>
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" stroke="#F9FAFB"/>
          <path d="M6 9.5H10.5L12 7.5L13.5 9.5H18V8H16.8L18 6.5L19.2 8H22V12H19.2L18 10.5L16.8 12H13.5L12 10L10.5 12H6V9.5Z" fill="#006FCF"/>
          <path d="M6 14.5H10.5L12 16.5L13.5 14.5H18V16H16.8L18 17.5L19.2 16H22V12H19.2L18 13.5L16.8 12H13.5L12 14L10.5 12H6V14.5Z" fill="#006FCF"/>
        </svg>

        <svg v-if="cardType === 'discover'" width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" fill="white"/>
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" stroke="#F9FAFB"/>
          <path d="M5 8H11V10H7V12H10V14H7V16H11V18H5V8Z" fill="#FF6000"/>
          <path d="M13 8H15V18H13V8Z" fill="#FF6000"/>
          <path d="M17 8H19.5C21.433 8 23 9.567 23 11.5V14.5C23 16.433 21.433 18 19.5 18H17V8ZM19 10V16H19.5C20.328 16 21 15.328 21 14.5V11.5C21 10.672 20.328 10 19.5 10H19Z" fill="#FF6000"/>
        </svg>

        <svg v-if="cardType === 'jcb'" width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" fill="white"/>
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" stroke="#F9FAFB"/>
          <path d="M5 8H8V16C8 17.105 8.895 18 10 18C11.105 18 12 17.105 12 16V8H15V16C15 18.761 12.761 21 10 21C7.239 21 5 18.761 5 16V8Z" fill="#006FCF"/>
          <path d="M16 8H22C23.105 8 24 8.895 24 10V14C24 15.105 23.105 16 22 16H16V8ZM19 11V13H21V11H19Z" fill="#006FCF"/>
        </svg>

        <svg v-if="cardType === 'diners'" width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" fill="white"/>
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" stroke="#F9FAFB"/>
          <circle cx="17" cy="12.5" r="6" fill="none" stroke="#0079BE" stroke-width="2"/>
          <path d="M11 12.5C11 9.186 13.686 6.5 17 6.5V18.5C13.686 18.5 11 15.814 11 12.5Z" fill="#0079BE"/>
        </svg>

        <svg v-if="cardType === 'unionpay'" width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" fill="white"/>
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" stroke="#F9FAFB"/>
          <path d="M6 8H12V10H8V12H11V14H8V16H12V18H6V8Z" fill="#E21836"/>
          <path d="M14 8H16V14H18V16H14V8Z" fill="#E21836"/>
          <path d="M20 8H26V18H24V10H22V18H20V8Z" fill="#E21836"/>
        </svg>

        <svg v-if="cardType === 'maestro'" width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" fill="white"/>
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" stroke="#F9FAFB"/>
          <circle cx="13" cy="12.5" r="5" fill="#0066CC"/>
          <circle cx="21" cy="12.5" r="5" fill="#ED0006"/>
          <path d="M17 8.5C18.4 9.8 19.2 11.6 19.2 13.5C19.2 15.4 18.4 17.2 17 18.5C15.6 17.2 14.8 15.4 14.8 13.5C14.8 11.6 15.6 9.8 17 8.5Z" fill="#CC0066"/>
        </svg>

        <svg v-if="cardType === 'mir'" width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" fill="white"/>
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" stroke="#F9FAFB"/>
          <rect x="6" y="8" width="22" height="8" rx="2" fill="#4DB45E"/>
          <path d="M8 10H12V16H8V10ZM14 10H18V16H14V10ZM20 10H24V16H20V10Z" fill="white"/>
        </svg>

        <svg v-if="cardType === 'troy'" width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" fill="white"/>
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" stroke="#F9FAFB"/>
          <path d="M6 8H28V18H6V8Z" fill="#00AEEF"/>
          <path d="M10 10H24V16H10V10Z" fill="white"/>
          <text x="17" y="14" text-anchor="middle" fill="#00AEEF" font-size="6" font-weight="bold">TROY</text>
        </svg>

        <svg v-if="cardType === 'elo'" width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" fill="white"/>
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" stroke="#F9FAFB"/>
          <circle cx="12" cy="12.5" r="4" fill="#FFCB05"/>
          <circle cx="22" cy="12.5" r="4" fill="#FF6900"/>
          <path d="M17 10C18.1 10.9 18.1 13.1 17 14C15.9 13.1 15.9 10.9 17 10Z" fill="#FF6900"/>
        </svg>

        <svg v-if="cardType === 'hipercard'" width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" fill="white"/>
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" stroke="#F9FAFB"/>
          <path d="M6 8H28V18H6V8Z" fill="#D50000"/>
          <text x="17" y="14" text-anchor="middle" fill="white" font-size="5" font-weight="bold">HIPER</text>
        </svg>

        <svg v-if="cardType === 'generic' || (!cardType && displayValue)" width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" fill="white"/>
          <rect x="0.5" y="1" width="33" height="23" rx="3.5" stroke="#F9FAFB"/>
          <rect x="2" y="8" width="30" height="3" fill="#E5E7EB"/>
          <rect x="2" y="14" width="8" height="2" fill="#E5E7EB"/>
          <rect x="12" y="14" width="6" height="2" fill="#E5E7EB"/>
          <rect x="20" y="14" width="4" height="2" fill="#E5E7EB"/>
        </svg>
      </div>
    </div>

    <div v-if="showDebug" class="debug-info">
      <small>Raw: {{ rawValue }} | Type: {{ cardType || 'none' }} | Valid: {{ isValidCard ? 'Yes' : 'No' }}</small>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, nextTick, watch } from 'vue'

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  showDebug: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'update:rawValue', 'card-type-changed', 'validation-changed'])

const cardInput = ref(null)
const displayValue = ref('')
const cursorPosition = ref(0)

const rawValue = computed(() => {
  return (displayValue.value || '').replace(/\D/g, '')
})

const cardType = computed(() => {
  const number = rawValue.value || ''
  if (!number) return null

  if (/^220[0-4]/.test(number)) return 'mir'

  if (/^(?:4011|4312|4389|4514|4573|5041|5066|5067|509[0-9]|6277|636[2-3]|650[4-5]|6550)/.test(number)) return 'elo'

  if (/^9792[0-8][0-9]/.test(number)) return 'troy'

  if (/^(?:3841|6062)/.test(number)) return 'hipercard'

  if (/^(?:35[2-8][0-9]|2131|1800)/.test(number)) return 'jcb'

  if (/^3[47]/.test(number)) return 'amex'

  if (/^3(?:0[0-5]|[68][0-9])/.test(number)) return 'diners'

  if (/^(?:5018|5020|5038|5893|6304|6759|676[1-3])/.test(number)) return 'maestro'

  if (/^6(?:011|5[0-9]{2}|4[4-9][0-9]|22(?:1(?:2[6-9]|[3-9][0-9])|[2-8][0-9]{2}|9(?:[01][0-9]|2[0-5])))/.test(number)) return 'discover'

  if (/^(?:62|88)/.test(number)) return 'unionpay'

  if (/^4/.test(number)) return 'visa'

  if (/^5[1-5]/.test(number) || /^2[2-7]/.test(number)) return 'mastercard'

  if (/^[3-6]/.test(number)) return 'generic'

  return null
})

const maxLength = computed(() => {
  const type = cardType.value
  if (type === 'amex') return 17
  if (type === 'diners') return 16
  return 19
})

const isValidCard = computed(() => {
  const number = rawValue.value || ''
  if (!number) return false

  const type = cardType.value
  const expectedLength = getExpectedLength(type)
  if (number.length !== expectedLength) return false

  return luhnCheck(number)
})

const getExpectedLength = (type) => {
  switch (type) {
    case 'amex': return 15
    case 'diners': return 14
    case 'visa':
    case 'mastercard':
    case 'discover':
    case 'jcb':
    case 'unionpay':
    case 'maestro':
    case 'mir':
    case 'troy':
    case 'elo':
    case 'hipercard':
    case 'generic':
    default: return 16
  }
}

const luhnCheck = (number) => {
  if (!number || typeof number !== 'string') return false

  let sum = 0
  let isEven = false

  for (let i = number.length - 1; i >= 0; i--) {
    let digit = parseInt(number[i])

    if (isNaN(digit)) continue

    if (isEven) {
      digit *= 2
      if (digit > 9) {
        digit -= 9
      }
    }

    sum += digit
    isEven = !isEven
  }

  return sum % 10 === 0
}

const formatCardNumber = (value) => {
  const digits = (value || '').replace(/\D/g, '')
  const type = getCardTypeFromDigits(digits)

  if (type === 'amex') {
    const limitedDigits = digits.substring(0, 15)

    if (limitedDigits.length === 15) {
      return limitedDigits.replace(/(\d{4})(\d{6})(\d{5})/, '$1 $2 $3')
    }
    else if (limitedDigits.length > 10) {
      return limitedDigits.replace(/(\d{4})(\d{6})(\d+)/, '$1 $2 $3')
    }
    else if (limitedDigits.length > 4) {
      return limitedDigits.replace(/(\d{4})(\d+)/, '$1 $2')
    }
    return limitedDigits
  }

  if (type === 'diners') {
    const limitedDigits = digits.substring(0, 14)

    if (limitedDigits.length === 14) {
      return limitedDigits.replace(/(\d{4})(\d{6})(\d{4})/, '$1 $2 $3')
    }
    else if (limitedDigits.length > 10) {
      return limitedDigits.replace(/(\d{4})(\d{6})(\d+)/, '$1 $2 $3')
    }
    else if (limitedDigits.length > 4) {
      return limitedDigits.replace(/(\d{4})(\d+)/, '$1 $2')
    }
    return limitedDigits
  }

  const limitedDigits = digits.substring(0, 16)
  return limitedDigits.replace(/(\d{4})(?=\d)/g, '$1 ')
}

const getCardTypeFromDigits = (digits) => {
  if (!digits || typeof digits !== 'string') return null

  if (/^220[0-4]/.test(digits)) return 'mir'

  if (/^(?:4011|4312|4389|4514|4573|5041|5066|5067|509[0-9]|6277|636[2-3]|650[4-5]|6550)/.test(digits)) return 'elo'

  if (/^9792[0-8][0-9]/.test(digits)) return 'troy'

  if (/^(?:3841|6062)/.test(digits)) return 'hipercard'

  if (/^(?:35[2-8][0-9]|2131|1800)/.test(digits)) return 'jcb'

  if (/^3[47]/.test(digits)) return 'amex'

  if (/^3(?:0[0-5]|[68][0-9])/.test(digits)) return 'diners'

  if (/^(?:5018|5020|5038|5893|6304|6759|676[1-3])/.test(digits)) return 'maestro'

  if (/^6(?:011|5[0-9]{2}|4[4-9][0-9]|22(?:1(?:2[6-9]|[3-9][0-9])|[2-8][0-9]{2}|9(?:[01][0-9]|2[0-5])))/.test(digits)) return 'discover'

  if (/^(?:62|88)/.test(digits)) return 'unionpay'

  if (/^4/.test(digits)) return 'visa'

  if (/^5[1-5]/.test(digits) || /^2[2-7]/.test(digits)) return 'mastercard'

  if (/^[3-6]/.test(digits)) return 'generic'

  return null
}

const handleInput = (event) => {
  if (!event?.target) return

  const inputValue = event.target.value || ''
  const cursorPos = event.target.selectionStart || 0

  const formatted = formatCardNumber(inputValue)
  const oldLength = (displayValue.value || '').length

  displayValue.value = formatted

  nextTick(() => {
    if (cardInput.value && formatted.length > oldLength) {
      let newPos = cursorPos
      if (formatted[cursorPos - 1] === ' ') {
        newPos = cursorPos + 1
      }
      cardInput.value.setSelectionRange(newPos, newPos)
    }
  })

  emit('update:modelValue', displayValue.value)
  emit('update:rawValue', rawValue.value)
}

const handleKeydown = (event) => {
  if (!event) return

  const allowedKeys = [
    'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
    'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
    'Home', 'End'
  ]

  const isNumber = /^[0-9]$/.test(event.key || '')
  const isAllowedKey = allowedKeys.includes(event.key)
  const isCtrlCmd = event.ctrlKey || event.metaKey

  if (!isNumber && !isAllowedKey && !isCtrlCmd) {
    event.preventDefault()
    return
  }

  if (event.key === 'Backspace' && event.target) {
    const cursorPos = event.target.selectionStart || 0
    const value = event.target.value || ''

    if (cursorPos > 0 && value[cursorPos - 1] === ' ') {
      event.preventDefault()
      const newValue = value.substring(0, cursorPos - 2) + value.substring(cursorPos)
      displayValue.value = formatCardNumber(newValue)

      nextTick(() => {
        if (cardInput.value) {
          cardInput.value.setSelectionRange(cursorPos - 2, cursorPos - 2)
        }
      })

      emit('update:modelValue', displayValue.value)
      emit('update:rawValue', rawValue.value)
    }
  }
}

const handlePaste = (event) => {
  if (!event?.clipboardData) return

  event.preventDefault()
  const pastedText = event.clipboardData.getData('text') || ''
  const digits = pastedText.replace(/\D/g, '')

  const detectedType = getCardTypeFromDigits(digits)
  let maxAllowedLength = 16

  if (detectedType === 'amex') {
    maxAllowedLength = 15
  } else if (detectedType === 'diners') {
    maxAllowedLength = 14
  }

  if (digits.length <= maxAllowedLength) {
    displayValue.value = formatCardNumber(digits)

    emit('update:modelValue', displayValue.value)
    emit('update:rawValue', rawValue.value)
  }
}

const handleFocus = () => {
  // Focus logic buraya eklenebilir
}

const handleBlur = () => {
  // Blur logic buraya eklenebilir
}

watch(cardType, (newType, oldType) => {
  if (newType !== oldType) {
    emit('card-type-changed', newType)
  }
})

watch(isValidCard, (isValid) => {
  emit('validation-changed', isValid)
})

// Initialize with props value
if (props.modelValue) {
  displayValue.value = formatCardNumber(props.modelValue)
}
</script>

<style scoped>
.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  min-width: 0;
  overflow: hidden;
}

.form-group label {
  font-size: 14px;
  color: #374151;
  margin-bottom: 8px;
  font-family: 'euclid_medium', sans-serif;
  text-align: left;
}

.card-input-container {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.card-input {
  width: 100%;
  box-sizing: border-box;
  border: none;
  outline: none;
  font-family: euclid_regular, sans-serif;
  font-size: 16px;
  background-color: #f5f5f5;
  color: #282A36;
  padding: 15px 60px 15px 15px;
  border-radius: 8px;
  height: 50px;
  transition: all 0.2s;
  letter-spacing: 0.5px;
}

.card-input:focus {
  background-color: #f0f0f0;
}

.card-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.card-input::placeholder {
  color: #9CA3AF;
  font-size: 14px;
}

.card-icons {
  position: absolute;
  right: 12px;
  display: flex;
  gap: 8px;
  pointer-events: none;
}

.debug-info {
  margin-top: 4px;
  color: #6B7280;
  font-size: 11px;
  font-family: monospace;
}

@media (max-width: 768px) {
  .card-input {
    font-size: 16px;
    padding: 12px 50px 12px 12px;
    height: 48px;
  }

  .card-icons {
    right: 8px;
  }
}
</style>
